module.exports = __webpack_public_path__ + "img/the-legal-500.2a450d4f.png";